import type { ReactNode } from "react";
import { cn } from "../../utils";
import { PART_CLASSES } from "../dateTimePickerStyles";
import { getPresetLabel } from "../presets";
import type { DateTimePickerClassNames, DateTimePickerPreset } from "../types";

/** Quick-select chips above the panel. Replaceable via `slots.presets`. */

interface DateTimePickerPresetsProps {
  presets: ReadonlyArray<DateTimePickerPreset>;
  onSelect: (preset: DateTimePickerPreset) => void;
  renderLabel?: (label: string) => ReactNode;
  classNames?: DateTimePickerClassNames;
}

export function DateTimePickerPresets({
  presets,
  onSelect,
  renderLabel,
  classNames,
}: DateTimePickerPresetsProps) {
  if (presets.length === 0) return null;

  return (
    <div
      data-part="presets"
      data-testid="datetimepicker-presets"
      className={cn(PART_CLASSES.presets, classNames?.presets)}
    >
      {presets.map((preset) => {
        const label = getPresetLabel(preset);
        return (
          <button
            key={label}
            type="button"
            onClick={() => onSelect(preset)}
            data-part="preset"
            className={cn(PART_CLASSES.presetButton, classNames?.presetButton)}
          >
            {renderLabel ? renderLabel(label) : label}
          </button>
        );
      })}
    </div>
  );
}
